import { UploadOutlined } from '@ant-design/icons'
import { Button, DatePicker, Form, Input, InputNumber, Upload } from 'antd'
import FormSection from 'components/form-section'
import dayjs from 'dayjs'
import React, { useEffect, useRef } from 'react'

const units = {
  wellboreLength: {
    FIELD: '(ft)',
    METRIC: '(m)'
  },
  wellboreDiameter: {
    FIELD: '(in)',
    METRIC: '(cm)'
  },
}

const WellSetting = () => {
  const isFirstRender = useRef(true)
  const form = Form.useFormInstance()

  const numberOfStages = Form.useWatch(['Completion', 'well', 'NUMBER_STAGES'])
  const simulationUnit = Form.useWatch(["GENERAL", "unit"])

  const updateStagesValues = (numberOfStages) => {
    if (!numberOfStages) return
    const currentStages = form.getFieldValue(["Completion", "hydraulic_fracture"]) ?? []
    
    if (currentStages.length > numberOfStages) {
      // Trim the stages array to match the new number of stages
      form.setFieldValue(["Completion", "hydraulic_fracture"], currentStages.slice(0, numberOfStages))
      return
    }
    
    if (currentStages.length < numberOfStages) {
      // Add new stages by copying data from the last existing stage
      const newStagesCount = numberOfStages - currentStages.length
      const lastStage = currentStages[currentStages.length - 1] || {
        MODEL: 'GENERIC',
        STAGE_LEN: 0,
        SAND_USAGE: 0,
        NUMBER_CLUSTERS: 0,
        PRIMARY: {
          FRACTURE_HALF_LEN: 0,
          VERTICAL_PENETRATION: 0,
          FRACTURE_WIDTH: 0
        },
        SECONDARY: {
          FRACTURE_HALF_LEN: 0,
          VERTICAL_PENETRATION: 0,
          FRACTURE_WIDTH: 0
        }
      }

      const stageArr = Array(newStagesCount).fill().map(() => ({
        ...JSON.parse(JSON.stringify(lastStage))  // Deep copy the last stage
      }))

      form.setFieldValue(["Completion", "hydraulic_fracture"], [...currentStages, ...stageArr])
    }
  }

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
      return;
    }
    updateStagesValues(numberOfStages)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [numberOfStages])

  return (
    <div className="vstack gap-4">
      <FormSection title="General">
        <Form.Item name={['Completion', 'well', 'WELL_NAME']} label="Well Name">
          <Input />
        </Form.Item>
      </FormSection>
      <FormSection title="Completion">
        <div className="row">
          <div className="col-6">
            <div className="vstack gap-4">
              <Form.Item name={['Completion', 'well', 'WELLBORE_LEN']} label={`Wellbore Length ${ units.wellboreLength[simulationUnit] }`}>
                <InputNumber className="w-100" />
              </Form.Item>
              <Form.Item name={['Completion', 'well', 'WELLBORE_DIAMETER']} label={`Wellbore diameter ${ units.wellboreDiameter[simulationUnit] }`}>
                <InputNumber className="w-100" />
              </Form.Item>
            </div>
          </div>
          <div className="col-6">
            <Form.Item name={['Completion', 'well', 'NUMBER_STAGES']} label="Number of stages">
              <InputNumber className="w-100" />
            </Form.Item>
          </div>
        </div>
      </FormSection>
      <FormSection title="Production">
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <Form.Item
            name={['Completion', 'well', 'DATE_INITIAL_PROD']}
            label="Date of initial production"
            getValueProps={(value) => ({
              value: value ? dayjs(value) : undefined
            })}
            style={{ marginBottom: 0 }} /* Ensures alignment */
          >
            <DatePicker format="YYYY-MM-DD" />
          </Form.Item>
          <Form.Item
            name={['Completion', 'well', 'BOTTOMHOLE_PRESSURE']}
            label={`Bottomhole Pressure ${simulationUnit === 'METRIC' ? '(bar)' : '(psi)'}`}
            style={{ marginBottom: 0 }} /* Ensures alignment */
            rules={[
              {
                pattern: /^\d+(\.\d+)?$/,
                message: 'Please enter a valid number (integer or decimal)'
              }
            ]}
          >
            <Input placeholder="Enter text" />
          </Form.Item>
          <Form.Item
            name={['Completion', 'well', 'MONTHS_OF_PRODUCTION']}
            label="Months of Production"
            style={{ marginBottom: 0 }} /* Ensures alignment */
            rules={[
              {
                pattern: /^\d+$/,
                message: 'Please enter a valid integer'
              }
            ]}
          >
            <Input placeholder="Enter integer" type="number" />
          </Form.Item>
        </div>
      </FormSection>


      {/* <FormSection title="Observation Data (optional)">
        <Upload accept="text/csv" multiple={false}>
          <Button icon={<UploadOutlined />}>Upload from local CSV file</Button>
        </Upload>
      </FormSection> */}
    </div>
  )
}

export default WellSetting